import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 确认 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("设置")

import stubs from '@/init';
import { reactive } from 'vue';
import { ElMessage } from 'element-plus';
import RiskRatingController from './controller/RiskRating.Controller';
import { RiskRatingSettingVO } from './vo';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const controller: RiskRatingController =
  stubs.injector.get(RiskRatingController);
const state = reactive({
  editRiskRatingSetting: {} as RiskRatingSettingVO,
  data: [] as Array<RiskRatingSettingVO>,
  dialogFormVisible: false,
});

const ruleForm = {};

const search = async () => {
  state.data = await controller.search();
};

const edit = (riskRatingSettingVO: RiskRatingSettingVO) => {
  state.editRiskRatingSetting = { ...riskRatingSettingVO };
  state.dialogFormVisible = true;
};

const confirm = async (riskRatingSettingVO: RiskRatingSettingVO) => {
  await controller.update(riskRatingSettingVO);
  ElMessage.success('创建/修改成功!');
  state.dialogFormVisible = false;
  search();
};

search();

return (_ctx: any,_cache: any) => {
  const _component_risk_rating_form = _resolveComponent("risk-rating-form")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_mas_form_main = _resolveComponent("mas-form-main")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_simple_table_column = _resolveComponent("simple-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_wapper = _resolveComponent("wapper")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_wapper, null, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_dialog, {
              modelValue: _unref(state).dialogFormVisible,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).dialogFormVisible) = $event)),
              title: '编辑',
              width: "600"
            }, {
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).dialogFormVisible = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$refs.masForm as any).confirm()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_component_mas_form_main, {
                  ref: "masForm",
                  form: _unref(state).editRiskRatingSetting,
                  defaultFormFooterButton: [],
                  ruleForm: ruleForm,
                  "label-width": "0px",
                  key: _unref(state).dialogFormVisible,
                  onConfim: confirm
                }, {
                  content: _withCtx((slotProps) => [
                    _createVNode(_component_el_form_item, { label: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_risk_rating_form, {
                          modelValue: slotProps.content.setting,
                          "onUpdate:modelValue": ($event: any) => ((slotProps.content.setting) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["form"]))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode(_component_el_table, {
            class: "common-table",
            data: _unref(state).data,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_simple_table_column, {
                label: "名称",
                prop: "name"
              }),
              _createVNode(_component_simple_table_column, {
                label: "修改时间",
                prop: "updateTime"
              }),
              _createVNode(_component_simple_table_column, { label: "操作" }, {
                default: _withCtx(({ row }: { row: RiskRatingSettingVO }) => [
                  _createVNode(_component_el_button, {
                    type: "text",
                    onClick: ($event: any) => (edit(row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})